/**
 * Viewport width (px) at or above which the Sidekick drawer stops
 * overlaying and the app shell shrinks its main column to make room.
 *
 * This one number feeds two places that must agree: the drawer's
 * `overlayBelowPx` and the `useSidekickContentInset` media query. The
 * side-panel primitive builds its overlay query as
 * `(max-width: value - 0.05px)` while the inset uses
 * `(min-width: value)`, so a viewport at exactly this width pushes
 * without also drawing a scrim.
 *
 * Chosen above the shared 1100px default because the CSP shell has
 * already spent up to 300px on the nav rail before the drawer takes
 * its 432px; below this, the remaining column is too narrow to read.
 */
export const SIDEKICK_PUSH_MIN_VIEWPORT_PX = 1280;
